import { IUserIdentity } from './IUserIdentity';
import { appConfig } from 'cd-eft/config/AppConfig';
import { EftUserIdentityProvider } from './EftUserIdentityProvider';
import { EAuthUserIdentityProvider } from './EAuthUserIdentityProvider';

let provider: IUserIdentity;
switch (appConfig.userIdentityProvider) {
  case 'EftUserIdentityProvider':
    provider = new EftUserIdentityProvider();
    break;
  case 'EAuthUserIdentityProvider':
    provider = new EAuthUserIdentityProvider();
    break;
  default:
    throw new Error('Unsupported application configuration value for "userIdentityProvider"');
}

export const UserIdentity: IUserIdentity = provider;

// console.log('+++++ UserIdentity Initialized +++++');
